<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const InstagramIcon = getIcon("InstagramIcon");
</script>

{#if typeof InstagramIcon === 'string'}
	<img src={InstagramIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof InstagramIcon === 'function'}
	<svelte:component this={InstagramIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
